module.exports = __webpack_public_path__ + "img/icon-services.c18c8ca6.png";